export enum CreepType {
  OPERATOR = 1,
  COMMANDER,
  EXECUTOR
}

export const CREEP_OPERATOR = CreepType.OPERATOR;
export const CREEP_COMMANDER = CreepType.COMMANDER;
export const CREEP_EXECUTOR = CreepType.EXECUTOR;



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/creep/creep.enum.ts